import type { ComponentPropsWithoutRef } from 'react';
import { ArrowRight } from 'lucide-react';

type ButtonArrowProps = Omit<
  ComponentPropsWithoutRef<typeof ArrowRight>,
  'aria-hidden' | 'className'
> & {
  className?: string;
  iconClassName?: string;
};

const ButtonArrow = ({
  className = 'h-4 w-4',
  iconClassName,
  ...props
}: ButtonArrowProps) => {
  const iconClasses = ['button-arrow__icon', iconClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      aria-hidden="true"
      className={['button-arrow', className].filter(Boolean).join(' ')}
    >
      <ArrowRight
        aria-hidden="true"
        className={`${iconClasses} button-arrow__icon--current`}
        {...props}
      />
      <ArrowRight
        aria-hidden="true"
        className={`${iconClasses} button-arrow__icon--incoming`}
        {...props}
      />
    </span>
  );
};

export { ButtonArrow };
